import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { RelatorioKardexService } from '../relatorio-kardex-service/relatorio-kardex.service';
import { Filtros } from './../../../../shared/crud/Filtro/Filtros';
import { ListaBase } from './../../../../shared/crud/ListaBase';
import { ExportExcelService } from './../../../../shared/excel-service/export-excel.service';
import { Parametro } from './../../../../shared/service-base/parametro';
import { DatePipe } from '@angular/common';
// import * as Papa from 'papaparse';

@Component({
  selector: 'app-relatorio-kardex-lista',
  templateUrl: './relatorio-kardex-lista.component.html',
  styleUrls: ['./relatorio-kardex-lista.component.css']
})
export class RelatorioKardexListaComponent extends ListaBase implements OnInit {

  periodo;
  anoFiltro;
  mesInicial;
  mesFinal;
  selectedValue: string;
  exibirAnaliseVenda: boolean = false;
  exibirAnaliseMargem: boolean = false;
  dadosKardex: any;
  dadosEstoque: any;
  dadosPecaRede: any;
  carregando = false;
  botao = false;

  constructor(toastr: ToastrService,
    router: Router,
    service: RelatorioKardexService,
    private servico: RelatorioKardexService,
    private exportExcel: ExportExcelService,
    private datePipe: DatePipe) {

    super(service, toastr, router);
    this.nomeModulo = 'relatorio-kardex';
  }

  ngOnInit(): void {
    this.selectedValue = 'estoque';
    this.servico.enviaValor(this.selectedValue);
    this.buscar();
  }

  buscar() {
    this.anoFiltro = this.filtros.ano;

    let objFiltro: Filtros = new Filtros();
    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        super.incluirItemFiltro(chave, objFiltro);
      }
    }
  }

  protected getListagemComFiltros(): boolean {
    if (this.selectedValue === 'peca_rede') {
      return !!(this.filtros.part_number && (typeof this.filtros.part_number !== 'string' || this.filtros.part_number.trim()));
    }
    return this.filtros.mercado
      || this.filtros.grupo_economico
      || this.filtros.regiao
      || this.filtros.regional
      || this.filtros.dealer
      || this.filtros.part_number
      || this.filtros.ano
      || this.filtros.mes_inicial
      || this.filtros.mes_final;
  }

  carregar() {
    const objFiltro = new Filtros();

    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        objFiltro.filtros.push(new Parametro(chave, this.filtros[chave]));
      }
    }
  }

  exportarExcel() {
    if (this.selectedValue === undefined) {
      alert('Selecione qual exportação deseja!');
      return '';
    }

    if (this.selectedValue === 'peca_rede') {
      if (!this.filtros.part_number || (typeof this.filtros.part_number === 'string' && !this.filtros.part_number.trim())) {
        this.toastr.error('Part Number é obrigatório para exportação Peças Rede.');
        return;
      }
    }

    if (parseFloat(this.filtros.mes_inicial) > parseFloat(this.filtros.mes_final)) {
      this.toastr.error('Filtro não permitido: Data inicial maior que data final.');
      this.filtros.mes_inicial = 1;
      this.filtros.mes_final = 12;
    } else {
      this.mesInicial = this.filtros.mes_inicial;
      this.mesFinal = this.filtros.mes_final;

      this.toastr.info('Aguarde a Impressão...', 'Informação', {
        timeOut: 10000
      });

      if (this.selectedValue == "kardex") {
        this.exportKardex();
      } else if (this.selectedValue == "estoque") {
        this.exportEstoque();
      } else if (this.selectedValue == "peca_rede") {
        this.exportPecaRede();
      }
    }
  }
  exportKardex() {
    this.botao = false;

    let objFiltro: Filtros = new Filtros();
    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        super.incluirItemFiltro(chave, objFiltro);
      }
    }

    this.servico.setUrl("/export_kardex");
    this.service.buscar(objFiltro).then(res => {
      if (this.listaExportacaoVazia(res && res.dados)) {
        this.avisarItemSemEstoque();
        return;
      }

      res.dados.forEach(item => {
        item.valor = this.formatarValorMonetario(item.valor);
      });

      this.exportExcel.exportToCsv(res.dados, 'export-kardex', ['codigo_dealer', 'data', 'descricao', 'id_kardex', 'part_number', 'quantidade', 'quantidade_final', 'transacao', 'numero_nf', 'valor', 'descricao_item']);
      this.botao = true;

    });
  }

  exportEstoque() {
    this.botao = true;

    let objFiltro: Filtros = new Filtros();
    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        super.incluirItemFiltro(chave, objFiltro);
      }
    }

    this.servico.setUrl("/export_estoque");
    this.service.buscar(objFiltro).then(res => {
      if (this.listaExportacaoVazia(res && res.dados)) {
        this.avisarItemSemEstoque();
        return;
      }

      res.dados.forEach(item => {
        item.custo = this.formatarValorMonetario(item.custo);
        item.total = this.formatarValorMonetario(item.total);
        item.valor_sugerido = this.formatarValorMonetario(item.valor_sugerido);
        item.data_compra = item.data_compra != undefined ? this.formatDate(item.data_compra) : '';
        item.data_ultima_venda = item.data_ultima_venda != undefined ? this.formatDate(item.data_ultima_venda) : '';
      });

      const csvData = this.exportExcel.exportToCsv(res.dados, 'export-estoque', ['codigo_dealer', 'part_number', 'descricao', 'disponivel', 'reserva', 'disponivel_sem_reserva', 'curva', 'custo', 'total', 'data_compra', 'data_ultima_venda', 'categoria_item', 'subgrupo','data_movimentacao', 'valor_sugerido']);

      // Verifique se o csvData não é undefined antes de criar o blob e o link de download
      if (csvData !== undefined) {
        const blob = new Blob(["\uFEFF" + csvData], { type: "text/csv;charset=utf-8" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = 'export-estoque.csv';
        a.click();
      }

      this.botao = false;
    });
  }

  exportPecaRede() {
    this.botao = true;

    const filtrosQuery: any = { part_number: this.filtros.part_number };

    this.servico.setUrl("/export_peca_rede");
    this.servico.buscarGet(filtrosQuery).then(res => {
      if (this.listaExportacaoVazia(res && res.dados)) {
        this.avisarItemSemEstoque();
        return;
      }

      res.dados.forEach(item => {
      });

      const colunas = ['codigo_dealer', 'part_number', 'descricao', 'disponivel', 'curva'];
      const titulos = ['Concessionaria', 'Codigo da Peca', 'Descricao', 'Disponivel', 'Classificacao'];
      const csvData = this.exportExcel.exportToCsv(res.dados, 'export-peca-rede', colunas, titulos);

      // Verifique se o csvData não é undefined antes de criar o blob e o link de download
      if (csvData !== undefined) {
        const blob = new Blob(["\uFEFF" + csvData], { type: "text/csv;charset=utf-8" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = 'export-peca-rede.csv';
        a.click();
      }

      this.botao = false;
    });
  }

  private listaExportacaoVazia(dados: any): boolean {
    return !dados || !dados.length;
  }

  private avisarItemSemEstoque(): void {
    this.botao = false;
    this.toastr.warning('Item não possui estoque');
  }

  formatarValorMonetario(valor) {

    const formatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
    });

    const valorFormatado = formatter.format(valor);
    const valorSemR = valorFormatado.replace('R$', '');

    return valorSemR.trim();
  }

  enviaValor() {
    this.servico.enviaValor(this.selectedValue);
  }

  formatDate(rawDate: string) {
    let cleanedDate = rawDate.replace(/\[UTC\]$/, ''); // Remove [UTC]
    return this.datePipe.transform(cleanedDate, 'dd/MM/yyyy');
  }

}
